import { IInputItems } from '@/typings';

export const viaDeAcesso: IInputItems[] = [
  { label: '1 - Única', value: '1' },
  { label: '2 - Mesma Via', value: '2' },
  { label: '3 - Diferentes vias', value: '3' },
];
